const STORAGE_LOCALE_KEY = 'HotelPortalLocale';

export default { STORAGE_LOCALE_KEY };
